import { render, staticRenderFns } from "./user-roles-table.vue?vue&type=template&id=74ca1f41&scoped=true"
import script from "./user-roles-table.vue?vue&type=script&lang=js"
export * from "./user-roles-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ca1f41",
  null
  
)

export default component.exports